







































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import Zan from "@/components/Zan.vue";
import AppPrompt from "@/components/AppPrompt.vue";
import Base from "@/template/public/Base.vue";
import request from "@/api/beibei/index";
import native from "@/common/Native";
import { Toast, List, PullRefresh, Dialog, Loading } from "vant";
import { ICommentItem } from "@/api/types";
import { IShareConfig } from "@/api/types";
import CommentItem from "@/components/CommentItem.vue";
import { wxChatShare } from "@/common/wechat";
import { wxChatJumpApp } from "@/common/wechatapp";
import { findNameByAppconfig } from "@/common/Utils";
import { dateFormat, findNameByWechatAppid, setImgSrc } from "@/common/Utils";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    VanList: List,
    VanPullRefresh: PullRefresh,
    CommentItem,
    Zan,
    AppPrompt,
    VanLoading: Loading
  }
})
export default class VideoPage extends Base {
  public request = new request();
  private commentList: ICommentItem[] = [];
  protected newsItem: any = {};
  private newsId?: number;
  private loading: boolean = false;
  private finished: boolean = false;
  private isLoading: boolean = false;
  private isOpenInApp: boolean = false;
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  private isExpand: boolean = false; // true 展开   false 收起
  private isFirstLoadedComment: boolean = false; // 解决评论初始化加载两次问题
  private lastCreateTime: string = "";
  private lastReplyId?: number;
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  private isRequestLoaded: boolean = false; //详情是否加载完成
  public appId: string = "";
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  wxAppId: any;
  created() {
    this.startTime = time();
  }
  mounted() {
    this.infoClassifyId =
      (this.$route.query.cid as string) || (this.$route.query.id as string);
    this.appId = (this.$route.query.appId as string) || "";
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);
    if (native.isOpenInApp()) {
      this.isOpenInApp = true;
      // get用户信息
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        // 新闻详情
        this.getNewsDetails().then(() => {
          this.getComments(true);
          this.getBussinessDetail();
        });
      });
    } else {
      this.isOpenInApp = false;
      // 新闻详情
      this.getNewsDetails().then(() => {
        this.getComments(true);
        this.getBussinessDetail();
      });
    }
  }
  switchEditor() {
    this.isExpand = !this.isExpand;
  }
  dateFormat(dateObj: Date, fmt: string): string {
    return dateFormat(dateObj, fmt);
  }
  getNewsDetails() {
    return this.request
      .getNewsDetails(this.infoClassifyId)
      .then(result => {
        this.isRequestLoaded = true;
        if (result.code == 0) {
          this.newsItem = result.data;
          this.newsId = result.data.id;
          this.newsItem.onlineTime = this.newsItem.onlineTime.toString();
          document.title = this.newsItem.title;
          this.$nextTick(() => {
            setImgSrc(this.$refs.synopsisContent as Element);
            this.handleVideo();
          });
          this.getCount();
          this.$nextTick(() => {
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, this.newsItem);
              this.dataSource = false;
            }
          });
        }
        this.isLoading = false;
        // 唤醒头部 赋值base.vue里detailGetAppId参数值
        this.getShareInfo(this.newsItem.appId);
        this.detailGetAppId = this.newsItem.appId;
      })
      .catch(() => {
        this.isRequestLoaded = true;
      });
  }
  getComments(isClear = true) {
    if (isClear) {
      // 如果要清除所有，重新加载，需要重置到第一页
      this.lastCreateTime = "";
      this.lastReplyId = undefined;
    }
    this.request
      .getCommentListPage(
        this.appId,
        this.userInfo.sessionId,
        this.newsItem.id,
        "1",
        this.lastCreateTime,
        this.lastReplyId,
        this.userInfo.token
      )
      .then(result => {
        if (isClear) {
          this.commentList = [];
        }

        if (result.data.dataList.length === 0) {
          this.finished = true;
        } else {
          this.commentList = this.commentList.concat(result.data.dataList);
          this.isLoading = false;
          this.loading = false;
          this.isFirstLoadedComment = true;
          this.lastCreateTime = result.data.dataList.lastChild
            .createTime as string;
          this.lastReplyId = result.data.dataList.lastChild.replyId;
        }
      });
  }
  // 下拉刷新
  onRefresh() {
    this.lastCreateTime = "";
    this.lastReplyId = undefined;
    this.finished = false;
    this.getNewsDetails().then(() => {
      this.getComments(true);
      this.getBussinessDetail();
    });
  }
  // 上拉加载评论列表
  onLoad() {
    if (this.newsId && this.isFirstLoadedComment) {
      this.getComments(false);
    }
  }
  /**业务详情 */
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        this.infoClassifyId,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0 && response.data) {
          this.businessDetail.isPraised = response.data.isPraised;
          // 微信一键唤醒
          var appInfo = this.$store.state.appInfo;
          var appConfig = findNameByAppconfig(
            appInfo,
            this.appId || (this.$route.query.appId as string)
          );
          const wechatConfigId = appConfig.wechatConfigId;
          const linkUrl = window.location.href;
          console.log(appConfig);
          if (
            linkUrl &&
            appConfig.realmUrl &&
            linkUrl.indexOf(appConfig.realmUrl) != -1
          ) {
            wxChatJumpApp(
              wechatConfigId,
              response.data.detailTitle,
              response.data.shareDescription,
              response.data.shareUrlWx,
              response.data.shareImgUrl
            );
          } else {
            wxChatShare(
              response.data.detailTitle,
              response.data.shareDescription,
              response.data.shareUrlWx,
              response.data.shareImgUrl
            );
          }
        }
      });
  }

  /**评论点赞 */
  doPraise(item: ICommentItem) {
    if (this.isOpenInApp) {
      this.request
        .doPraise(
          this.infoClassifyId,
          this.appId,
          this.userInfo.sessionId,
          item.replyId,
          1,
          "1",
          1,
          this.userInfo.token,
          new Date().getTime()
        )
        .then((response: any) => {
          if (response.code >= 0) {
            if (response.data) {
              this.getComments(true);
              //积分
              if (response.data.point && response.data.point > 0) {
                try {
                  ZWY_CLOUD.showPointView({
                    message: "点赞成功！",
                    point: response.data.point
                  });
                } catch (e) {
                  ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                }
              } else {
                ZWY_CLOUD.appAlert({ message: "点赞成功！" });
              }
            }
          } else {
            ZWY_CLOUD.appAlert({ message: response.message });
          }
        })
        .catch((error: any) => {
          ZWY_CLOUD.appAlert({ message: error.toString() });
        });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        this.openApp(this.newsItem);
      });
    }
  }
  /**新闻点赞 */
  articleDoPraise() {
    if (this.isOpenInApp) {
      this.request
        .doPraise(
          this.infoClassifyId,
          this.appId,
          this.userInfo.sessionId,
          this.newsItem.informationId, // 暂时的评论id
          1,
          "1",
          0,
          this.userInfo.token,
          new Date().getTime()
        )
        .then((response: any) => {
          if (response.code >= 0) {
            if (response.data) {
              // 假点赞成功-图标变红和+1
              this.businessDetail.isPraised = true;
              isNaN(Number(this.businessDetail!.praiseCount))
                ? ""
                : (this.businessDetail!.praiseCount =
                    Number(this.businessDetail!.praiseCount) + 1);
              //积分
              if (response.data.point && response.data.point > 0) {
                try {
                  ZWY_CLOUD.showPointView({
                    message: "点赞成功！",
                    point: response.data.point
                  });
                } catch (e) {
                  ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                }
              } else {
                ZWY_CLOUD.appAlert({ message: "点赞成功！" });
              }
            }
          } else {
            ZWY_CLOUD.appAlert({ message: response.message });
          }
        });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        this.openApp(this.newsItem);
      });
    }
  }
  /**到详情页 */
  toCommentDetail() {
    let param = {
      id: this.infoClassifyId,
      informationId: this.newsItem.informationId,
      sourceType: this.newsItem.sourceType,
      newsCommentType: this.newsItem.commentType
    };
    let jsonParam = {
      iOS: "CQCommentDetailController",
      Android: "goToFamous",
      par: param
    };
    if (native.isOpenInApp()) {
      native.pushToController(jsonParam);
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        this.openApp(this.newsItem);
      });
    }
  }
  //图片预览
  toImagePreview(item: any) {
    if (native.isOpenInApp()) {
      native.viewImageContent({
        array: [
          {
            imgUrl: item.imageUrl,
            desc: ""
          }
        ],
        index: 0
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        this.openApp(this.newsItem);
      });
    }
  }
  getCount() {
    // 在app外才需要增加浏览量 接口做了ua判断不需要前端判断是否在app内
    this.request.getCount(this.appId, this.infoClassifyId).then((res: any) => {
      if (res.code >= 0 && res.data) {
        this.businessDetail.viewCount = res.data.showViewCount;
        this.businessDetail.praiseCount = res.data.showPraiseCount;
        this.businessDetail.replyCount = res.data.showReplyCount;
      }
    });
  }
}
